import getServerUrl from "Utilities/server-url";

export const defaultUrl = getServerUrl() || process.env.REACT_APP_SERVER_URL;
export const serverUrl = process.env.REACT_APP_LISTENER_URL;
export const paymentUrl = process.env.REACT_APP_PAYMENT_URL;

export const multitenantBaseURL = "/api/MultiTenant";
export const subscriptionConfigBaseURL = "/api/SubscriptionConfiguration";

export const multitenantRoutes = {
  login: `${multitenantBaseURL}/Login`,
  logout: `${multitenantBaseURL}/Logout`,
  allTenants: `${multitenantBaseURL}/AllTenantsWithOrganization`,
  saveTenant: `${multitenantBaseURL}/TenantInfo`,
  updateTenant: `${multitenantBaseURL}/UpdateTenantInfo`,
  deleteTenant: `${multitenantBaseURL}/DeleteTenantInfo`,
  getOrganizations: `${multitenantBaseURL}/GetOrganizations`,
  organizations: `${multitenantBaseURL}/Organization`,
  addOrganization: `${multitenantBaseURL}/Organization`,
  checkMultiTenantDb: `${multitenantBaseURL}/CheckMultiTenantRepoExistence`,
  setupMultiTenantDbAndDefaultTenant: `${multitenantBaseURL}/AddMultiTenantRepoAndDefaultTenant`,
  GetAllUsers: `${multitenantBaseURL}/GetAllUsers`,
  AddUser: `${multitenantBaseURL}/AddUser`,
  AuthenticateAzureUser: `${multitenantBaseURL}/AuthenticateAzureUser`,
  GetMonolithInfo: `${serverUrl}/api/GetMonolithInfo`,
  UpgradeReposForAllTenants: `${multitenantBaseURL}/UpgradeAllTenantsRepo`,
  UpgradeRepoDataForAllTenants: `${multitenantBaseURL}/UpgradeAllTenantsRepoData`,
  UpgradeLandlordDatabase: `${multitenantBaseURL}/UpgradeLandlordDb`,
  getExceptions: `${multitenantBaseURL}/Exceptions`,
  deleteUser: `${multitenantBaseURL}/DeleteCloudPortalUser`,
  updateUser: `${multitenantBaseURL}/UpdateCloudPortalUserInfo`,
  createTenantLicense: `${multitenantBaseURL}/TenantLicense`,
  getLicenseTiers: `${multitenantBaseURL}/LicenseTiers`,
  getPackageNames: `${multitenantBaseURL}/PackageNames`,
  getLicenseSettings: `${multitenantBaseURL}/LicenseSettings`,
  getSupportedFileFormats: `${multitenantBaseURL}/SupportedFileFormats`,
  ListGlobalStorageFiles: `${multitenantBaseURL}/ListGlobalStorageFiles`,
  UpgradeSelectedTenantsFlows: `${multitenantBaseURL}/UpgradeSelectedTenantsFlows`,

  UpgradeTenantRepo : `${multitenantBaseURL}/UpgradeTenantRepo`,
};

export const subscriptionConfigRoutes = {
  // Feature Groups
  featureGroups: `${subscriptionConfigBaseURL}/feature-groups`,
  createFeatureGroup: `${subscriptionConfigBaseURL}/feature-groups`,
  updateFeatureGroup: `${subscriptionConfigBaseURL}/feature-groups`,
  deleteFeatureGroup: `${subscriptionConfigBaseURL}/feature-groups`,
};


export const baseServerApiURL = "api";

export const dbAgentBaseUrl = `${baseServerApiURL}/db`;

export const dbAgentRoutes = {
  dbProviders: `${dbAgentBaseUrl}/DbProviders`,
  getDabases: `${dbAgentBaseUrl}/GetDatabases`,
};
